/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ amount: NonNullable<unknown> }} Carrier_Form_Submit_With_AmountInputs */

const vi_carrier_form_submit_with_amount = /** @type {(inputs: Carrier_Form_Submit_With_AmountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tạo vận đơn · thu ${i?.amount}đ`)
};

/**

* @param {Carrier_Form_Submit_With_AmountInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_form_submit_with_amount = /** @type {((inputs: Carrier_Form_Submit_With_AmountInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Form_Submit_With_AmountInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_form_submit_with_amount(inputs)
});